module.exports = __webpack_public_path__ + "img/logo-dark.1d0b3689.png";